import gql from 'graphql-tag'

const query = gql`query AppUserById(
    $id: String!
) {
    appUserById(id: $id) {
        id
        createdAt
        username
        avatarKey
        contact: contactByContactId {
            fullName
            firstName
            lastName
        }
    }
}
`
export default query
